import View from '../../view.js';

namespace('IO.Views.Components', function (exports) {
  'use strict';

  var InternetAddress = View.extend({
    dom: {
      PROTOCOL: '.internet-address.protocol',
      HOST: '.internet-address.host',
    },

    events: function () {
      var self = this;

      $(this.el).find(this.dom.PROTOCOL).select2();

      $(this.el)
        .find(this.dom.HOST)
        .select2(
          window.select2Defaults({
            acceptNotFound: true,
            allowClear: true,
            placeholder: 'domain.com',
          }),
        )
        .on('change', function (e) {
          self._validateFields(e);
        });
    },

    _validateFields: function (e) {
      var element = $(e.target),
        val = element.val(),
        validDomain =
          /^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9][a-zA-Z0-9-]+\.[a-zA-Z]{2,6}?$/i,
        validIp = /^(?:\d{1,3}\.){3}\d{1,3}$/,
        removeErrors = function () {
          element.removeClass('field_with_errors');
          element.closest('td').find('small.error').remove();
        },
        allowedOptions,
        errorContainer;

      if (val == '') {
        removeErrors();
        return;
      }

      if (!element.attr('data-validate')) {
        return;
      }

      try {
        allowedOptions = JSON.parse(
          $('#' + $(e.target).data('validate')).val(),
        );

        if (
          allowedOptions.indexOf(val) == -1 &&
          !val.match(validIp) &&
          !val.match(validDomain)
        ) {
          throw new Error('Domain or IP Address invalid');
        }

        removeErrors();
      } catch (error) {
        errorContainer = element.closest('td').find('small.error');

        element.addClass('field_with_errors');
        if (errorContainer.length > 0) {
          errorContainer.text(error.message);
        } else {
          element
            .closest('td')
            .append('<small class="error">' + error.message + '</small>');
        }
      }
    },
  });

  exports.InternetAddress = InternetAddress;
});
